import config from '../utils/ApiUrl';
import { getCookie, handleSessionExpire } from './session';

const API_URL = config.API_URL;

const restrictedFieldsService = {
  getFields: async () => {
    const sessionToken = getCookie();
    if (!sessionToken) return handleSessionExpire();

    const response = await fetch(`${API_URL}/restricted-fields`, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${sessionToken}`,
      },
    });
    const data = await response.json();
    return data;
  },

  deleteField: async (formdata) => {
    const sessionToken = getCookie();
    if (!sessionToken) return handleSessionExpire();

    await fetch(
      `${API_URL}/delete-rectricted-field/${formdata.id}/${formdata.password}`,
      {
        method: 'DELETE',
        headers: {
          Authorization: `Bearer ${sessionToken}`,
        },
      }
    );
  },

  addField: async (formdata) => {
    const sessionToken = getCookie();
    if (!sessionToken) return handleSessionExpire();

    const response = await fetch(`${API_URL}/add-restricted-field`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${sessionToken}`,
      },
      body: JSON.stringify(formdata),
    });
    const data = await response.json();
    return data;
  },
};

export default restrictedFieldsService;
